import * as BaseIngredientCategory from 'types/Ingredient/Detail/BaseIngredientCategory';

export type Type = BaseIngredientCategory.Type[];

export function create(): Type {
	return [];
}
